import { useMutation, useQueryClient } from '@tanstack/react-query';

import { markAllNotificationsRead, markNotificationRead } from '@/api/notifications';
import {
  applyMarkAllRead,
  applyMarkRead,
  restoreNotifications,
  snapshotNotifications,
} from './cache';
import { notificationKeys } from './keys';

export function useMarkNotificationRead() {
  const client = useQueryClient();

  return useMutation({
    mutationFn: (id: string) => markNotificationRead(id),
    onMutate: async (id) => {
      await client.cancelQueries({ queryKey: notificationKeys.all });
      const snapshot = snapshotNotifications(client);
      applyMarkRead(client, id);

      return snapshot;
    },
    onError: (_error, _id, snapshot) => {
      if (snapshot) {
        restoreNotifications(client, snapshot);
      }
    },
    onSettled: () => client.invalidateQueries({ queryKey: notificationKeys.unreadCount() }),
  });
}

export function useMarkAllNotificationsRead() {
  const client = useQueryClient();

  return useMutation({
    mutationFn: () => markAllNotificationsRead(),
    onMutate: async () => {
      await client.cancelQueries({ queryKey: notificationKeys.all });
      const snapshot = snapshotNotifications(client);
      applyMarkAllRead(client);

      return snapshot;
    },
    onError: (_error, _vars, snapshot) => {
      if (snapshot) {
        restoreNotifications(client, snapshot);
      }
    },
    onSettled: () => client.invalidateQueries({ queryKey: notificationKeys.unreadCount() }),
  });
}
